import { FunctionComponent } from "react";
import { StyledField } from "./field.styles";

interface FieldProps {
  children: any;
  className?: string;
}

const Field: FunctionComponent<FieldProps> = ({ children, className }) => {
  return <StyledField className={className}>{children}</StyledField>;
};

export default Field;
